import {Layout, Typography, Anchor} from 'antd';
import React, {useState} from 'react';
import appColors from '../../style/theme';
import ImprovingInsight from './ImprovingInsight';
import ImprovingSol from './ImprovingSol';

const {Link} = Anchor;
const {Sider, Content} = Layout;
const {Text} = Typography;
const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};

const ImprovingPage = () => {
  const [backI, setBackI] = useState('transparent');
  const [backII, setBackII] = useState('transparent');
  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#HPSolution') {
      setBackI(appColors['ColorD']);
      setBackII('transparent');
    } else if (key === '#HPInsight') {
      setBackI('transparent');
      setBackII(appColors['ColorD']);
    }
  };
  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#HPSolution' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorD'], fontSize: '3vh'}}>Our Design</Text></Content>}/>
          <Link href='#HPInsight' title={<Content className='ContentAnchor' style={{borderColor: backII}}><Text style={{color: appColors['ColorD'], fontSize: '1.4vh'}}>Technical Components</Text></Content>}/>
        </Anchor>
        <p style={{color: appColors['ColorD'], pointerEvents: 'none', fontSize: '2vh', top: '65vh', left: '5vh', textAlign: 'center', position: 'sticky'}}> I&nbsp;<br/> M&nbsp;<br/> P&nbsp;<br/> R&nbsp;<br/> O&nbsp;<br/> V&nbsp;<br/> I&nbsp;<br/> N&nbsp;<br/> G&nbsp;</p>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['Colorx'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0 0 0 0', background: 'transparent'}}>
            <div id='HPSolution'>
              <ImprovingSol/>
            </div>
            <div id='HPInsight'>
              <ImprovingInsight/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default ImprovingPage;

